export default "__VITE_ASSET__CACKyk3a__"